<header class="pt-topbar header-card-grid" [ngClass]="cssClassesGallery">
  <div class="container pt-4" [class.mt-3]="galleryLength === 3">
    <div class="row gutter-3 gutter-md-4" [@CardGridAnimation]="header().headerEvents?.length">
      <div class="" [ngClass]="galleryLength === 2 ? 'col-md-24' : 'col-md-12'">
        <article class="ps-lg-5 pe-lg-5 text-light" [ngClass]="galleryLength === 2 ? 'section-inset-t' : 'section-inset-y '">
          <h1 class="h1">{{ header().title }}</h1>
          @if (header().intro; as intro) {
            <p class="max-lines-4" fstrDynamicContent [innerHTML]="intro | resizeHtmlImages | stripEmbed: undefined | safe">
              {{ intro }}
            </p>
          }

          @if (header().button?.url || header().button?.url) {
            <div class="mt-sm-4 d-flex flex-wrap gap-3">
              @if (header().button?.url) {
                <fstr-link [button]="header().button!" [cssClasses]="'button button--accent'" [showText]="false">
                  @if (header().button?.text) {
                    <span>{{ header().button?.text }}</span>
                  }
                  @if (false) {
                    <fstr-icon [anchor]="'line-icon-arrow-down'"></fstr-icon>
                  } @else {
                    <fstr-icon [anchor]="'line-icon-arrow-right'"></fstr-icon>
                  }
                </fstr-link>
              }
              @if (header().secondaryButton?.url) {
                <fstr-link [button]="header().secondaryButton!" [cssClasses]="'button button-link button--light'" [showText]="false">
                  @if (header().secondaryButton?.text) {
                    <span>{{ header().secondaryButton?.text }}</span>
                  }
                  @if (false) {
                    <fstr-icon [anchor]="'line-icon-arrow-down'"></fstr-icon>
                  } @else {
                    <fstr-icon [anchor]="'line-icon-arrow-right'"></fstr-icon>
                  }
                </fstr-link>
              }
            </div>
          }
        </article>
        @if (header().headerEvents; as events) {
          @if (events.length > 2) {
            @for (event of events | slice: 0 : 1; track event.event) {
              <app-featured-event-card class="d-block card--anim" [event]="event.event"></app-featured-event-card>
            }
          }
        }
      </div>

      <div
        class=""
        [class.pt-md-6]="galleryLength === 1"
        [ngClass]="galleryLength === 2 ? 'col-md-24 d-md-flex gap-3 gap-lg-4' : 'col-md-12 mt-3 mt-md-0'"
      >
        @if (header().headerEvents; as events) {
          @if (events.length > 2) {
            @for (event of header().headerEvents | slice: 1 : 3; track event.event.id; let i = $index) {
              <app-featured-event-card class="d-block mb-3 mt-md-4 card--anim flex-1" [event]="event.event"></app-featured-event-card>
            }
          } @else {
            @for (event of header().headerEvents | slice: 0 : 2; track event.event.id; let i = $index) {
              <app-featured-event-card class="d-block mb-3 mt-md-4 card--anim flex-1" [event]="event.event"></app-featured-event-card>
            }
          }
        }
      </div>
    </div>
  </div>
</header>
